import React from 'react';

import { appLogger } from '@/utils/app-logger/appLogger';

import ErrorBoundaryContent from './ErrorBoundaryContent';

interface ErrorBoundaryProps {
    children: React.ReactNode;
    fallback?: React.ReactNode;
}

interface ErrorBoundaryState {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(_error: Error): ErrorBoundaryState {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        appLogger.error(
            'Error caught by ErrorBoundary:',
            { componentStack: errorInfo.componentStack },
            error,
        );
    }

    render(): React.ReactNode {
        if (this.state.hasError) {
            return this.props.fallback || <ErrorBoundaryContent />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
